import { computed, ref } from 'vue'

export const REMINDERS_VISITED_KEY = 'remindersPageVisited'

const isVisited = ref<boolean>(Boolean(localStorage.getItem(REMINDERS_VISITED_KEY)))

export function useRemindersIndicator () {
  const isIndicatorVisible = computed<boolean>(() => !isVisited.value)

  function markVisited (): void {
    if (isVisited.value) {
      return
    }
    isVisited.value = true
    localStorage.setItem(REMINDERS_VISITED_KEY, '1')
  }

  return { isIndicatorVisible, markVisited }
}
